import { gql } from '@apollo/client';

const GET_INTERACTIVE_COMPONENT_STATE = gql`
  query InteractiveComponentState(
    $userId: String!
    $studyGroupId: String!
    $componentId: String!
  ) {
    getInteractiveContentState(
      userId: $userId
      studyGroupId: $studyGroupId
      componentId: $componentId
    ) {
      state
      # hash
    }
  }
`;

const SAVE_INTERACTIVE_COMPONENT_STATE = gql`
  mutation SaveInteractiveComponentState(
    $data: InteractiveComponentStateInput!, $reset: Boolean
  ) {
    saveInteractiveComponentState(data: $data, reset: $reset) {
      state
    }
  }
`;

export { GET_INTERACTIVE_COMPONENT_STATE, SAVE_INTERACTIVE_COMPONENT_STATE };
